import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { DischargeLetterCardiologyFormSchema } from "./schema";
import { DischargeLetterCardiologyFormSections } from "./sections";

export const getDischargeLetterCardiologyFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
> = () => {
  return {
    // todo: make this optional
    auctionToForm: () => {
      return {
        additional_diagnostic_findings: () => undefined,
        allergies: () => undefined,
        anamnesis: () => undefined,
        diagnoses: () => undefined,
        discharge_medications: () => undefined,
        ecg: () => undefined,
        other_information: () => undefined,
        physical_status: () => undefined,
        previous_diagnoses: () => undefined,
        social_history: () => undefined,
        therapy_and_course: () => undefined,
      };
    },
    getInitialValue: ({ value }) => {
      return {
        additional_diagnostic_findings:
          value?.additional_diagnostic_findings ?? "",
        allergies: value?.allergies ?? "",
        anamnesis: value?.anamnesis ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        ecg: value?.ecg ?? "",
        other_information: value?.other_information ?? "",
        physical_status: value?.physical_status ?? "",
        previous_diagnoses: value?.previous_diagnoses ?? "",
        social_history: value?.social_history ?? "",
        therapy_and_course: value?.therapy_and_course ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formCardiology.title,
    schema: DischargeLetterCardiologyFormSchema,
    sections: DischargeLetterCardiologyFormSections,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formCardiology.sectionTitle,
  };
};
